'use strict';

angular.module('supervisorAuthorizingUserRequestControllers')

.controller('CardSupervisorAuthorisingRequestController', ['$scope', '$state', function ($scope, $state) {

    // Display actions
    $scope.displayActions = false;

    $scope.showOrHideActions = function ($event) {
        $scope.displayActions = !$scope.displayActions;
        $event.stopPropagation();
    }

    // View Request
    $scope.viewRequest = function () {
        $state.go('supervisorAuthorizingUserRequest_ByRequest.Authorize',
                  { userAccessRequestId: $scope.request.UserAccessRequestID });
    }
}]);